import React from 'react';

import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import { FlexColumn } from 'src/components/flex';
import FactRow from 'src/components/lead-sidebar/FactRow';

export default function LeadInfo({ lead }: { lead: ILead }) {
    const displayedUUID = lead.uuid.slice(0, 10) + '...';

    return (
        <ExpandableItem title="Lead Info" defaultExpanded={false}>
            <FlexColumn rowGap={1.5} pb={1}>
                <FactRow
                    label="Reffie ID"
                    value={displayedUUID}
                    copyText={lead.uuid}
                    factKey="reffie-id"
                />
            </FlexColumn>
        </ExpandableItem>
    );
}
